import dayjs from 'dayjs';
import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';

type UploadDayGroup = {
  key: string;
  heading: string;
  isToday: boolean;
  files: UploadedFile[];
};

export const groupFilesByUploadDay = (files: UploadedFile[]): UploadDayGroup[] => {
  const sorted = [...files].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  const buckets = new Map<string, UploadedFile[]>();
  for (const file of sorted) {
    const key = dayjs(file.createdAt).format('YYYY-MM-DD');
    const existing = buckets.get(key);
    if (existing) {
      existing.push(file);
    } else {
      buckets.set(key, [file]);
    }
  }

  return [...buckets.entries()].map(([key, groupFiles]) => {
    const isToday = dayjs(key).isSame(dayjs(), 'day');
    return {
      key,
      heading: isToday ? 'Uploaded today' : `Uploaded ${dayjs(key).format('MMMM D')}`,
      isToday,
      files: groupFiles,
    };
  });
};
